export default __webpack_public_path__ + "static/media/acc-buildings.f15c1173.svg";